import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export class VideoSlider {
  container: String

  constructor(container: String) {
    this.container = container
    this.initSlider()
  }

  initSlider() {
    new Swiper(this.container, {
      autoplay: {
        delay: 3500,
      },
      speed: 1000,
      slidesPerView: 1,
      grabCursor: true,
      watchSlidesProgress: true,
      effect: 'fade',
    })
  }
}
